import { render, staticRenderFns } from "./CollapsedContainer.vue?vue&type=template&id=42231231&scoped=true"
import script from "./CollapsedContainer.vue?vue&type=script&lang=js"
export * from "./CollapsedContainer.vue?vue&type=script&lang=js"
import style0 from "./CollapsedContainer.vue?vue&type=style&index=0&id=42231231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42231231",
  null
  
)

export default component.exports